<div class="row m-3" *ngIf="isReadOnly">
    <div class="col-12 d-flex justify-content-center">
        <div class="w-100" style="max-width: 1400px;">
            <!-- Readonly: Stacked layout matching details component -->
            <div class="readonly-width">
                <div class="row" *ngIf="selectedFeatureScope === 'Global'; else notGMB">
                    <div class="col-12">
                        <h4>You must navigate to the New Menu Pilot to edit common items</h4>
                        <br>
                        <p>Please note that our initial release does not include the functionality to edit common items, however,
                            you
                            can view the full common item UI rather than the more compact instance UI shown in Menu Viewer.
                        </p>
                        <br>
                        <button
                            (click)="editCommonItem()"
                            mat-raised-button
                            class="edit-common-item-button"
                            matTooltip="Navigate to the common items management section">
                            <mat-icon>edit</mat-icon>
                            Edit Common Items
                        </button>
                    </div>
                </div>
                <ng-template #notGMB>
                    <div class="row">
                        <div class="col-12">
                            <button
                                (click)="editCommonItem()"
                                mat-raised-button
                                class="edit-common-item-button"
                                matTooltip="Navigate to the common items management section">
                                <mat-icon>edit</mat-icon>
                                You are viewing an instance of a common item
                            </button>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>

<div *ngIf="!isLoading && selectedItem && selectedFeatureScope !== 'Global'">
    <emm-common-item-details
        [selectedItem]="selectedItem"
        [isReadOnly]="true"
        [useStoreData]="true"
        [context]="context$ | async">
    </emm-common-item-details>
</div>
